<div class="container">
  <p-toast></p-toast>
  <nav class="navbar navbar-expand-md navbar-light bg-faded">
    <div class="container-fluid">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
        (click)="toggleCollapse()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-between" id="navbarNav" [ngStyle]="{display: isCollapsed ? 'none' : 'block'}">
        <!-- On the left side of our navbar we'll display the two links for public and private deals -->
        @if (authService.loggedIn()) {
          <ul class="nav navbar-nav mr-auto">
            <li class="nav-item">
              <a class="nav-link" routerLink="/dashboard" routerLinkActive="active">Home</a>
            </li>
            @if (showMenu('/overview')) {
              <li class="nav-item">
                <a class="nav-link" routerLink="/overview" routerLinkActive="active">Dashboard</a>
              </li>
            }
            @if (showMenu('/apoc')) {
              <li class="nav-item">
                <a class="nav-link" routerLink="/apoc" routerLinkActive="active">Apoc</a>
              </li>
            }
            @if (showMenu('/diagnostic')) {
              <li class="nav-item">
                <a class="nav-link" routerLink="/diagnostic" routerLinkActive="active">Diagnostic</a>
              </li>
            }
            @if (showMenu('/podium')) {
              <li class="nav-item">
                <a class="nav-link" routerLink="/podium" routerLinkActive="active">Podium</a>
              </li>
            }
            @if (showMenu('/mpodium')) {
              <li class="nav-item">
                <a class="nav-link" routerLink="/mpodium" routerLinkActive="active" (click)="toggleCollapse()">Mobile Podium</a>
              </li>
            }
            @if (showMenu('/mtransitions')) {
              <li class="nav-item">
                <a class="nav-link" routerLink="/mtransitions" routerLinkActive="active" (click)="toggleCollapse()">Transitions</a>
              </li>
            }
            @if (showMenu('/brigadier')) {
              <li class="nav-item">
                <a class="nav-link" routerLink="/brigadier" routerLinkActive="active">Brigadier</a>
              </li>
            }
            @if (showMenu('/persons')) {
              <li class="nav-item">
                <a class="nav-link" routerLink="/persons" routerLinkActive="active">Persons</a>
              </li>
            }
            @if (showMenu('/vehicles')) {
              <li class="nav-item">
                <a class="nav-link" routerLink="/vehicles" routerLinkActive="active">Vehicles</a>
              </li>
            }
            @if (showMenu('/keys')) {
              <li class="nav-item">
                <a class="nav-link" routerLink="/keys" routerLinkActive="active">Keys</a>
              </li>
            }
            @if (showMenu('/locks')) {
              <li class="nav-item">
                <a class="nav-link" routerLink="/locks" routerLinkActive="active">Locks</a>
              </li>
            }
            @if (showMenu('/areas')) {
              <li class="nav-item">
                <a class="nav-link" routerLink="/areas" routerLinkActive="active">Areas</a>
              </li>
            }
            @if (showMenu('/system')) {
              <li class="nav-item dropdown" >
                <a class="nav-link dropdown-toggle" href="#" role="button" id="dropdown1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">System</a>
                <ul class="dropdown-menu" aria-labelledby="dropdown1">
                  @if (showMenu('/companies')) {
                    <li class="dropdown-item">
                      <a class="nav-link" routerLink="/companies" routerLinkActive="active">Companies</a>
                    </li>
                  }
                  @if (showMenu('/admins')) {
                    <li class="dropdown-item">
                      <a class="nav-link" routerLink="/admins" routerLinkActive="active">Administrators</a>
                    </li>
                  }
                  @if (showMenu('/settings')) {
                    <li class="dropdown-item">
                      <a class="nav-link" routerLink="/settings" routerLinkActive="active">Settings</a>
                    </li>
                  }
                </ul>
              </li>
            }
            @if (showMenu('/reporting')) {
              <li class="nav-item">
                <a class="nav-link" href="reporting/">Reporting</a>
              </li>
            }
            @if (showMenu('/debug') || showMenu('/transitions')) {
              <li class="nav-item dropdown" >
                <a class="dropdown-toggle nav-link" href="#" role="button" id="dropdown2" data-bs-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">Debug</a>
                <ul class="dropdown-menu" aria-labelledby="dropdown2">
                  @if (showMenu('/debug')) {
                    <li class="nav-item">
                      <a class="nav-link" routerLink="/debug" routerLinkActive="active">Debug board</a>
                    </li>
                  }
                  @if (showMenu('/transitions')) {
                    <li class="nav-item">
                      <a class="nav-link" routerLink="/transitions" routerLinkActive="active">Car Transitions</a>
                    </li>
                  }
                </ul>
              </li>
            }
          </ul>
        }
        @else {
          <ul class="nav navbar-nav mr-auto">
            <li class="nav-item">
              <a class="nav-link" routerLink="/" routerLinkActive="active">Home</a>
            </li>
          </ul>
        }

        <!-- On the right side of our navbar we'll display the login and logout actions depending on user state -->
        <ul class="nav navbar-nav">
          <li class="nav-item">
            @if (!authService.loggedIn()) {
              <a class="nav-link" routerLink="/" (click)="authService.signUp()">Log In{{authService.authError()}}</a>
            }
          </li>
          <li class="nav-item">
            @if (authService.loggedIn()) {
              <a class="nav-link" routerLink="/" (click)="authService.logout()">Log Out{{authService.authError()}}</a>
            }
          </li>
          <li class="nav-item ms-auto d-flex align-items-center">
            <span>v.{{version}}</span>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <div class="col-sm-12 content-area">
    <router-outlet></router-outlet>
  </div>
</div>
